import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

export default createUseStyles(
  {
    root: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 36px)',
      gap: theme.spacing.sp02,
      padding: theme.spacing.sp03,
    },
  },
  {
    name: 'Month',
  },
);

export const useHeaderStyles = createUseStyles(
  {
    day: {
      color: theme.colors.textTertiary,
      height: 36,
      width: 36,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      userSelect: 'none',
    },
  },
  {
    name: 'MonthHeader',
  },
);
